import styled from "styled-components"
import { Header } from "../components/Header"
import { ErrorMessage } from "../components/ErrorMessage"
import { Button } from "../components/Button"
import { useCheckLogic } from "./check.logic"
import { InformationMessage } from "../components/InformationMessage"

const Input = styled.input`
    display: block;
    margin: 10px auto;
    width: 250px;
    font-size: 16px;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid black;
    padding: 7px;
`

export const CheckPage = () => {

    const { setLocationField, errorMessage, data, checkPalleteLocation, showData } = useCheckLogic();

    return (
        <>
            <Header title={"SPRAWDŹ"} subtitle={"PALETE"} />
            <Input name="location" onChange={(e) => setLocationField(e.target.value)} placeholder="Lokalizacja np. D-02-09-1/3" />
            <Button onClick={() => checkPalleteLocation()} text="Sprawdź palete"/>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <InformationMessage>Podaj lokalizację palety, której ma zostać wyświetlona zawartość.</InformationMessage>
            {data && showData()}
        </>
    )
}